package com.appcreator.client.firebase.messaging

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.options

actual fun getGcmSenderId(): String = Firebase.options.gcmSenderId ?: ""